import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import fragments from './fragments/fragments.js'
import prefs from './prefs/prefs.js'
import page from './page.js'

export default contract({
  fragments,
  prefs,
  page: array([
    page
  ])
})

